'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Pages = void 0;
var tslib_1 = require("tslib");
var transport_1 = require("../../transport");
var Pages = /** @class */ (function () {
    function Pages() {
    }
    Pages.prototype.get = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var page, slug, lang;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, transport_1.transport.request('pages/get', params)];
                    case 1:
                        page = _a.sent();
                        // API gives empty response instead of error when page is not found
                        // TODO: remove the block below when the API issue is fixed
                        if (!page) {
                            slug = params.slug, lang = params.lang;
                            throw new Error("Page '" + slug + "' not found for '" + lang + "' language");
                        }
                        return [2 /*return*/, page];
                }
            });
        });
    };
    return Pages;
}());
exports.Pages = Pages;
